
.root {
    page-break-inside: avoid;
    /* layout */
    --crop-area-width: 14.5cm;
    --crop-area-height: 9.5cm;
    --crop-mark-size: 0.7cm;
    display: grid;
    grid-template-columns: var(--crop-mark-size) var(--crop-area-width) var(--crop-mark-size);
    grid-template-rows: var(--crop-mark-size) var(--crop-area-height) var(--crop-mark-size);
    grid-template-areas:
            "top-left . top-right"
            ". content ."
            "bottom-left . bottom-right";
}

.topLeft {
    grid-area: top-left;
}

.topLeft > img {
    transform: rotate(180deg);
    width: 100%;
    height: 100%;
}

.topRight {
    grid-area: top-right;
}

.topRight > img {
    transform: rotate(270deg);
    width: 100%;
    height: 100%;
}

.bottomLeft {
    grid-area: bottom-left;
}

.bottomLeft > img {
    transform: rotate(90deg);
    width: 100%;
    height: 100%;
}

.bottomRight {
    grid-area: bottom-right;
}

.bottomRight > img {
    transform: rotate(0deg);
    width: 100%;
    height: 100%;
}

.cropArea {
    composes: defaults from "printout.module.css";
    grid-area: content;
    /* enable the children to fill all space */
    display: flex;
    /* add print preview markers */
    outline: 1px solid lightgray;
}

@media print {
    .root {
        /* print margins */
        padding-top: 8mm; /* XXX: padding instead of margin, because else only first page has top margin */
        margin-left: 8mm;
    }

    .cropArea {
        /* remove print preview markers */
        outline: none;
    }
}
